import { SelectItem } from 'primeng/api';
import { CreditType } from '../enums/credit-type';

export class CreditTypeLookup {

    static getAllLookup(): SelectItem[] {
        return [
            { label: 'All', value: null },
            { label: 'Visa', value: CreditType.Visa },
            { label: 'Installment', value: CreditType.Installment },
        ];
    }

        static getLookup(): SelectItem[] {
        return [
            { label: 'Visa', value: CreditType.Visa },
            { label: 'Installment', value: CreditType.Installment },
        ];
    }

    static getTitleById(id) {
        return this.getAllLookup().find(f => f.value === id)?.label || '';
    }
}
